export default ({ request }) => ({
  ecomAmzFbaInvMonitorListApi(data = {}) {
    return request({
      url: '/ecom/amz/fba/invmonitor/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFbaInvMonitorLevelGroupApi(data = {}) {
    return request({
      url: '/ecom/amz/fba/invmonitor/level/group',
      method: 'POST',
      data,
    })
  },
})
